import { handleActions } from 'redux-actions';

const defaultState = {
  showAside: false,
  showSourceInput: false,
  showCategoriesInput: false,
  showCameraInput: false,
  showBatchInput: false,
  showImageSnInput: false,
  showInfraredModeInput: false,
  showImageSizeInput: false,
  showImageTimeInput: false,
  gridImageSize: 'medium', // Only 'small', 'medium' or 'large' type display
  listFontSize: 'medium', // Only 'small', 'medium' or 'large' type display
  imageSizeSearchMode: 'disabled', // Only 'disabled', 'range', 'maximum' or 'exact' type display
  gridScrollPosition: 0,
  scrollContainer: null
};

const toggleActionHandlerConstructor = toggleParameter => state => ({
  ...state,
  [toggleParameter]: !state[toggleParameter]
});
const updateActionHandlerConstructor = switchParameter => (state, { payload }) => ({
  ...state,
  [switchParameter]: payload
});

const UIReducer = handleActions(
  {
    TOGGLE_ASIDE: toggleActionHandlerConstructor('showAside'),
    TOGGLE_SOURCE_INPUT: toggleActionHandlerConstructor('showSourceInput'),
    TOGGLE_CATEGORIES_INPUT: toggleActionHandlerConstructor('showCategoriesInput'),
    TOGGLE_CAMERA_INPUT: toggleActionHandlerConstructor('showCameraInput'),
    TOGGLE_BATCH_INPUT: toggleActionHandlerConstructor('showBatchInput'),
    TOGGLE_IMAGE_ID_INPUT: toggleActionHandlerConstructor('showImageIDInput'),
    TOGGLE_INFRARED_MODE_INPUT: toggleActionHandlerConstructor('showInfraredModeInput'),
    TOGGLE_IMAGE_SIZE_INPUT: toggleActionHandlerConstructor('showImageSizeInput'),
    TOGGLE_IMAGE_TIME_INPUT: toggleActionHandlerConstructor('showImageTimeInput'),
    SWITCH_GRID_IMAGE_SIZE: updateActionHandlerConstructor('gridImageSize'),
    SWITCH_LIST_FONT_SIZE: updateActionHandlerConstructor('listFontSize'),
    SWITCH_IMAGE_SIZE_SEARCH_MODE: updateActionHandlerConstructor('imageSizeSearchMode'),
    UPDATE_GRID_SCROLL_POSITION: updateActionHandlerConstructor('gridScrollPosition'),
    SET_SCROLL_CONTAINER: updateActionHandlerConstructor('scrollContainer')
  },
  defaultState
);

export default UIReducer;



// WEBPACK FOOTER //
// ./src/reducers/UIReducer.js